{
  "table": {
    "newBanner": "New Banner",
    "name": "Name",
    "roleProfiles": "Role Profiles",
    "lastUpdated": "Last Updated",
    "activeDateRange": "Active Date Range",
    "status": {
      "title": "Status",
      "states": {
        "DRAFT": "Draft",
        "SCHEDULED": "Scheduled",
        "ACTIVE": "Active",
        "EXPIRED": "Expired"
      }
    },
    "organization": "Organization",
    "actions": {
      "delete": "Delete",
      "setToDraft": "Set to Draft"
    }
  },
  "useParentAlertBanners": "Inherit alert banners from parent organization",
  "alertBanner": "alert banner",
  "newBanner": "New Alert Banner",
  "editBanner": "Edit Alert Banner",
  "transitionError": "This banner is no longer available",
  "bannerForm": {
    "name": "Name",
    "roleProfile": {
      "title": "Role Profile(s)",
      "placeholder": "Select all that apply"
    },
    "bannerType": {
      "title": "Banner Type",
      "INFO": "Info: Use for information about new features, app updates, etc.",
      "SUCCESS": "Success: Use for communicating a positive or affirmative event.",
      "WARNING": "Warning: Use for high priority information such as upcoming system maintenance.",
      "URGENT": "Urgent: Use for urgent communications such as a fraud or security alert."
    },
    "bannerCopy": {
      "title": "Banner Copy (150 character limit)",
      "placeholder": "Enter banner copy here"
    },
    "configuration": {
      "displayOnWeb": "Display on web portal",
      "displayOnIOS": "Display on iOS app",
      "displayOnAndroid": "Display on Android app",
      "makeDismissible": "Make dismissible",
      "enableAction": "Enable action button"
    },
    "actionButton": {
      "url": "URL",
      "label": "Button Label",
      "urlError": "Enter a valid URL starting with http:// or https://"
    },
    "persistenceBehaviour": {
      "title": "Persistence Behaviour",
      "FIRST_SESSION": {
        "title": "Show in first session",
        "description": "Display the first time the user logs in, but not in subsequent sessions."
      },
      "EVERY_SESSION": {
        "title": "Show in every session",
        "description": "Display during every new session within the Active Date Range, even if the user dismisses the banner."
      },
      "UNTIL_DISMISSED": {
        "title": "Show until dismissed",
        "description": "Display during every session until the user dismisses the banner."
      },
      "UNTIL_ACTIONED": {
        "title": "Show until actioned",
        "description": "Display during every session until the users clicks the associated action button."
      }
    },
    "activeDateRange": {
      "startDate": "Start Time ({{timeZone}})",
      "endDate": "End Time ({{timeZone}})"
    },
    "actions": {
      "preview": {
        "title": "Preview",
        "close": "Close"
      },
      "saveDraft": "Save Draft",
      "scheduleBanner": "Schedule Banner",
      "updateBanner": "Update Banner",
      "activateImmediately": {
        "title": "Activate Immediately",
        "description": "The Active Date Range includes the current day which means the banner will display immediately.",
        "cancel": "Cancel",
        "confirm": "Confirm"
      },
      "toasts": {
        "draftSaved": "Draft saved.",
        "bannerStatus": "New alert banner has been {{status}}.",
        "activated": "activated",
        "scheduled": "scheduled"
      }
    }
  },
  "filterModal": {
    "title": "Filter",
    "status": "Status",
    "cancel": "Cancel",
    "apply": "Apply",
    "showStatus": "Show {{status}}"
  },
  "alertBannerDeleteModal": {
    "deleteAlertBanner": "Delete Alert Banner?",
    "untitled": "Untitled",
    "wantToProceed": "You're about to delete {{name}} alert banner. This action cannot be undone.",
    "deletedSuccessfully": "Alert banner deleted successfully.",
    "setToDraftSuccessfully": "Alert banner set to draft successfully."
  }
}
